import { render } from "./P013.vue?vue&type=template&id=37bb708d&scoped=true"
import script from "./P013.vue?vue&type=script&lang=js"
export * from "./P013.vue?vue&type=script&lang=js"

import "./P013.vue?vue&type=style&index=0&id=37bb708d&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bb708d"]])

export default __exports__